import { render } from "./index.vue?vue&type=template&id=73f5e01e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=73f5e01e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-73f5e01e"

export default script